/* eslint-disable prettier/prettier */
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import ReactDataTable from '../../../ReactDataTable/ReactDataTable';

const FeaturesOptionalForm = ({ remove, add }) => {
    const { values } = useFormikContext();
    const column = [
        // {
        //     name: 'Features Name',
        //     cell: (_, i) => <ReactInput name={`features[${i}].name`} />,
        // },
        {
            name: 'Value',
            cell: (_, i) => <ReactInput name={`features_optional[${i}].value`} />,
        },
        {
            name: <Button onClick={() => add({})}>
                <span style={{
                    fontSize: '14px'
                }}>
                    Add <FaPlus />
                </span>
            </Button>,
            width: '120px',
            cell: (_, i) => (
                <div>
                    {i === 0 ? (
                        <>
                            <Button onClick={() => add({})}>
                                <FaPlus />
                            </Button>
                            <span> </span>
                            <Button onClick={() => remove(i)}>
                                <FaMinus />
                            </Button>
                        </>
                    ) : (
                        <Button onClick={() => remove(i)}>
                            <FaMinus />
                        </Button>
                    )}
                </div>
            ),
        },
        // {
        //     name: <Button onClick={() => add({})}>
        //         <span style={{
        //             fontSize: '14px'
        //         }}>
        //             Action <FaPlus />
        //         </span>
        //     </Button>,
        //     width: '120px',
        //     cell: (_, i) => (
        //         <div>
        //             {i === 0 ? (
        //                 <Button onClick={() => add({})}>
        //                     <FaPlus />
        //                 </Button>
        //             ) : (
        //                 <Button onClick={() => remove()}>
        //                     <FaMinus />
        //                 </Button>
        //             )}
        //         </div>
        //     ),
        // },
    ];
    // Log
    console.log('values features_optional =>', values.features_optional);
    return (
        <div>
            <ReactDataTable columns={column} data={values.features_optional} pagination={false} />
        </div>
    );
};
export default FeaturesOptionalForm;
